module.exports = __webpack_public_path__ + "img/hero_sp.1bc4e954.jpg";